import React from 'react';
import { Modal, DatePicker, notification } from 'antd';
import { newJob } from '../../store/models/Jobs/jobsAPI';

class ReCatModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        applyBtnDisabled: true,
        startDate: "",
    };

    this.setApplyBtnDisabled = this.setApplyBtnDisabled.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.disabledDate = this.disabledDate.bind(this);
    this.displayResults = this.displayResults.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  displayResults() {
    notification.open({
      message: 'Success',
      description:
        'A new Categorization Job has been created.',
    });
  }

  handleOk() {
    let data = {};
    let now = new Date(),
        catArray = [];
    console.log('#### startDate: ',this.state.startDate);
    data.dateBegin = this.state.startDate;
    data.dateEnd = now.toISOString();
    data.jobType = "BOTH";
    catArray.push(this.props.categoryObj.categoryName);
    data.categories = catArray;
    newJob(JSON.stringify(data), this.props.token).then(this.displayResults);
    this.props.closeModal();
  }

  handleCancel() {
    this.props.closeModal();
  }

  onChange(date, dateString) {
    console.log(date._d, dateString);
    this.setState({
      startDate: date._d,
    });
    this.setApplyBtnDisabled(false)
  }

  setApplyBtnDisabled(isDisabled) {
    this.setState({
      applyBtnDisabled: isDisabled,
    })
  }

  disabledDate(current) {
    const today = new Date();
    const start = (new Date()).setMonth(today.getMonth() - 3);
    return !current || current > today || current < start;
  }

  render() {

    return (<Modal
      title="Re-Apply Category"
      visible={this.props.showReCatModal}
      onOk={this.handleOk}
      onCancel={this.handleCancel}
      okText="Re-Apply"
      okButtonProps={{'disabled': this.state.applyBtnDisabled}}
    >
      <h4 style={{ marginBottom: "15px" }}>
        Choose a date to start Re-Applying this Category from:
      </h4>
      <DatePicker disabledDate={this.disabledDate} onChange={this.onChange} format={"MM/DD/YYYY"} />
    </Modal>)
  }
}

export default ReCatModal;
